import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Pagination,
  alpha,
  useTheme,
} from "@mui/material";

const BreakDetailsTable = ({
  breakDetails,
  currentPage,
  itemsPerPage,
  onPageChange,
}) => {
  const theme = useTheme();

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedDetails = breakDetails.slice(startIndex, endIndex);
  const totalPages = Math.ceil(breakDetails.length / itemsPerPage);

  return (
    <>
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 1,
        }}
      >
        <Table>
          <TableHead
            sx={{
              bgcolor: alpha(theme.palette.grey[500], 0.05),
            }}
          >
            <TableRow>
              <TableCell
                sx={{
                  fontWeight: 600,
                  color: "text.secondary",
                }}
              >
                SN
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 600,
                  color: "text.secondary",
                }}
              >
                Start Time
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 600,
                  color: "text.secondary",
                }}
              >
                End Time
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 600,
                  color: "text.secondary",
                }}
               
              >
                Duration
              </TableCell>

              <TableCell
                sx={{
                  fontWeight: 600,
                  color: "text.secondary",
                }}
                align="right"
              >
                Break Reason
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedDetails.length > 0 ? (
              paginatedDetails.map((detail, detailIndex) => (
                <TableRow
                  key={detailIndex}
                  sx={{
                    "&:last-child td, &:last-child th": {
                      border: 0,
                    },
                  }}
                >
                  <TableCell>{startIndex + detailIndex + 1}</TableCell>
                  <TableCell>{detail.start_date}</TableCell>
                  <TableCell>{detail.end_date}</TableCell>
                  <TableCell >
                    {detail.duration}
                  </TableCell>
                  <TableCell align="right" sx={{ fontWeight: 500 }}>{detail.break_reason}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <Typography variant="caption" color="text.secondary">
                    No specific break logs found.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      {breakDetails.length > itemsPerPage && (
        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(event, value) => onPageChange(value)}
            color="primary"
            size="small"
            shape="rounded"
          />
        </Box>
      )}
    </>
  );
};

export default BreakDetailsTable;
